export default __webpack_public_path__ + "static/contact-img-71ccec92531e0f5a57feb8c853f743de.png";